import React from 'react'
import moment from 'moment'
import OperacionesCamionesParaNormalizar from '../../camionesParaAutorizar/components/OperacionesCamionesSinCupo'

export const COLUMNS_CAMIONES_SIN_CUPO = [
  {
    name: 'numero',
    label: 'Carta Porte',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'fechaDeIngresoTimestamp',
    label: 'Ingreso',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD/MM/YY HH:mm')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: []
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: [],
      display: false,
      customBodyRender: (v) => {
        return ((v.trim() === 'UNDEF') ? '-' : v)
      }
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'titularDeCupo',
    label: 'Titular Cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'fechaCupoDate',
    label: 'Fecha Cupo',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        return <div>{ f ? moment(f).format('DD/MM/YY') : null }</div>
      }
    }
  },
  {
    name: 'turnoSinCupo',
    label: 'Turno sin Cupo',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'codigoCupo',
    label: 'Codigo Cupo',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'arribo',
    label: 'Arribo',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: false
    }
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'telefono',
    label: 'Teléfono Entregador',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'autodescargable',
    label: 'Autodescargable',
    options: {
      filter: true,
      sort: true,
      display: false,
      filterList: [],
      customBodyRender: autodescargable => {
        return (autodescargable) ? 'Si' : '  '
      }
    }
  },
  {
    name: 'numero',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: numero => {
        return <OperacionesCamionesParaNormalizar numero={numero} />
      }
    }
  }
]
